function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 6.016L26.328.352 16 10.655 5.673.344 0 6.016 16 22z"
});

function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 32 22",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjIyIiB2aWV3Qm94PSIwIDAgMzIgMjIiIHdpZHRoPSIzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMzIgNi4wMTYtNS42NzItNS42NjRzLTMuNDQyNjY2NyAzLjQzNDMxNTk3LTEwLjMyOCAxMC4zMDI5NDc5bC0xMC4zMjctMTAuMzEwOTQ3OS01LjY3MyA1LjY3MiAxNiAxNS45ODR6Ii8+PC9zdmc+";
export { SvgCaret as ReactComponent };